export default __webpack_public_path__ + "static/adebisi-a4e60aeb4ff77e0845f413476b3ed69b.png";